import React from 'react'
import {Grid, useStyleConfig} from '@chakra-ui/react'

import PropTypes from 'prop-types'
import CompareTable from './compare-table'

const getUniqueTruthy = (values = []) => [...new Set(values.filter(Boolean))]

const buildCategoryTableData = (accordionData, slotCount = accordionData?.length || 0) => {
    if (!accordionData || accordionData.length === 0) {
        return []
    }

    const allCategories = getUniqueTruthy(accordionData.flat().map((item) => item.accordion_title))

    return allCategories.map((categoryLabel) => {
        const allValueNames = getUniqueTruthy(
            accordionData.flatMap((items = []) => {
                const category = items.find((item) => item.accordion_title === categoryLabel)
                return Array.isArray(category?.values)
                    ? category.values.map((value) => value.value_name)
                    : []
            }),
        )

        const rows = allValueNames.map((valueName) => ({
            id: valueName,
            label: valueName,
            values: Array.from({length: slotCount}, (_, slotIndex) => {
                const slotItems = accordionData?.[slotIndex] || []
                const category = slotItems.find((item) => item.accordion_title === categoryLabel)
                if (!Array.isArray(category?.values)) return '-'
                const value = category.values.find((row) => row.value_name === valueName)
                return value ? value.value ?? '-' : '-'
            }),
        }))

        return {categoryLabel, rows}
    })
}

const CompareTables = ({
    accordionData,
    numOfProducts,
    visibleColumns,
    gridGap,
    hideIdenticalRows = false,
}) => {
    const dataToDisplay = buildCategoryTableData(accordionData, numOfProducts)
    const styles = useStyleConfig('ProductComparePlp')

    return (
        <Grid {...styles.compareTableGrid}>
            {dataToDisplay.map((table) => (
                <CompareTable
                    key={table.categoryLabel}
                    dataToDisplay={table.rows}
                    numOfProducts={numOfProducts}
                    visibleColumns={visibleColumns}
                    categoryLabel={table.categoryLabel}
                    gridGap={gridGap}
                    hideIdenticalRows={hideIdenticalRows}
                />
            ))}
        </Grid>
    )
}

CompareTables.propTypes = {
    accordionData: PropTypes.array,
    numOfProducts: PropTypes.number,
    visibleColumns: PropTypes.arrayOf(PropTypes.bool),
    gridGap: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hideIdenticalRows: PropTypes.bool,
}

export default CompareTables
